import { isInShadow } from "@/utils/isInShadow";

interface ClickOutsideOptions {
    include?: HTMLElement[];
}

const clickOutside = (
    node: HTMLElement,
    _options: ClickOutsideOptions = {}
): {
    destroy: () => void;
} => {
    const options: Required<ClickOutsideOptions> = {
        include: [],
        ..._options,
    };

    function detect(event: MouseEvent | TouchEvent) {
        const target = isInShadow(node)
            ? event.composedPath()[0]
            : event.target;

        if (
            !node.contains(target as HTMLElement) &&
            !options.include.some((i) => i.contains(target as HTMLElement))
        ) {
            node.dispatchEvent(new CustomEvent("clickOutside"));
        }
    }
    document.addEventListener("click", detect, {
        passive: true,
        capture: true,
    });
    document.addEventListener("touchstart", detect, {
        passive: true,
        capture: true,
    });

    return {
        destroy() {
            document.removeEventListener("click", detect);
            document.removeEventListener("touchstart", detect);
        },
    };
};

export default clickOutside;
